export const BLOB_CONFIG = {
  "background": "#1d0e00",
  "gradientMap": "Custom",
  "gradientColor1": "#896f40",
  "gradientColor2": "#9a8e6b",
  "gradientColor3": "#4e4040",
  "uPositionFrequency": 1.9300000000000002,
  "uPositionStrength": 0.43000000000000005,
  "uSmallWavePositionFrequency": 0.29,
  "uSmallWavePositionStrength": 0.67,
  "uSmallWaveTimeFrequency": 0.19,
  "uTimeFrequency": 0.17,
  "roughness": 0.61,
  "metalness": 0.36,
  "envMapIntensity": 1.86,
  "clearcoat": 0,
  "clearcoatRoughness": 0,
  "transmission": 0.52,
  "wireframe": true,
  "flatShading": false,
  "autoRotate": true,
  "autoRotateSpeed": 1.7
}